import { render, staticRenderFns } from "./SeniorsChoir.vue?vue&type=template&id=4d0237a3&"
import script from "./SeniorsChoir.vue?vue&type=script&lang=js&"
export * from "./SeniorsChoir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports